import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
@Pipe({
  name: 'customDate',
})
export class CustomDatePipe extends DatePipe implements PipeTransform {
  override transform(
    value: any,
    format: string = 'medium',
    timezone: string = 'UTC'
  ): any {
    const date = new Date(value);
    const targetDate = this.convertToTimeZone(value, timezone);
    console.log(targetDate)
    return super.transform(targetDate, format);
  }
  ///Función que se encarga de tomar una fecha y hora como entrada y la convierte en la fecha y hora local específica
  private convertToTimeZone(date: Date, timezone: string): Date {

    const utcDate = new Date(date.toISOString());
    const timeZoneOffset = utcDate.getTimezoneOffset() / 60;
    const targetOffset = this.getTimeZoneOffset(timezone);
    const offsetDifference = timeZoneOffset - targetOffset;
    const targetDate = new Date(
      utcDate.getTime() + offsetDifference * 60 * 60 * 100
    );
    console.log(targetDate)
    return targetDate;
  }
  // Function to get the time zone offset
  private getTimeZoneOffset(timeZone: string): number {
    const date = new Date();
    const dateString = date.toLocaleString('en-US', { timeZone: timeZone });
    const localDate = new Date(dateString);
    const localOffset = localDate.getTimezoneOffset() / 60;
    console.log(localOffset)

    return localOffset;
  }
}